import { faApple, faGooglePlay } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';
import { backgroundColor, primaryText } from 'styles/themeProperties';

const APP_STORE_URL = '';
const PLAY_STORE_URL = '';

const StyledLink = styled.a`
    display: flex;
    padding: 6.5px 6px 6.5px 8px;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    gap: 8px;
    flex-grow: 0;
    border-radius: 6px;
    border: 1px solid ${primaryText};
    background: ${backgroundColor};
    color: ${primaryText};
`;

export type AppStoreButtonProps = Readonly<{
    type: 'apple' | 'google-play';
}>;

export function AppStoreButton({ type }: AppStoreButtonProps) {
    return (
        <>
            {type === 'google-play' && (
                <StyledLink
                    style={{ width: '14rem' }}
                    href={PLAY_STORE_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <FontAwesomeIcon icon={faGooglePlay} size="xl" />
                    <div className="flex-column">
                        <div className="f-9">GET IT ON</div>
                        <div className="f-18">Google Play</div>
                    </div>
                </StyledLink>
            )}
            {type === 'apple' && (
                <StyledLink
                    style={{ width: '12rem' }}
                    href={APP_STORE_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <FontAwesomeIcon icon={faApple} size="2xl" />
                    <div className="flex-column">
                        <div className="f-9">Download on the</div>
                        <div className="f-18">App Store</div>
                    </div>
                </StyledLink>
            )}
        </>
    );
}
